// src/services/api.js
import axios from "axios";
import { Preferences } from "@capacitor/preferences";
import router from "@/router/index";

const api = axios.create({
  baseURL: "https://mvexpress.mx/api/",
  timeout: 12000,
});

/* ===========================
   REQUEST → Access Token
=========================== */
api.interceptors.request.use(async (config) => {
  const { value } = await Preferences.get({ key: "auth_session" });

  if (value) {
    const session = JSON.parse(value);
    config.headers.Authorization = `Bearer ${session.token}`;
  }

  return config;
});

/* ===========================
   RESPONSE → Refresh Token
=========================== */
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const { value } = await Preferences.get({
          key: "auth_session",
        });

        if (!value) throw new Error("No session");

        const session = JSON.parse(value);
        if (!session.refreshToken) throw new Error("No refresh token");

        // 🔁 NO usar api aquí (evita loop infinito)
        const res = await axios.post(
          "https://mvexpress.mx/api/refresh-token",
          { refreshToken: session.refreshToken }
        );

        const newToken = res.data.token;

        // 🧠 Actualizar sesión completa
        const updatedSession = {
          ...session,
          token: newToken,
        };

        await Preferences.set({
          key: "auth_session",
          value: JSON.stringify(updatedSession),
        });

        // 🔄 Reintentar request original
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest);

      } catch (err) {
        console.warn("🔐 Sesión expirada, cerrando sesión");
        await Preferences.remove({ key: "auth_session" });
        router.push('/login');
      }
    }

    return Promise.reject(error);
  }
);

export default api;
